import $ from "jquery";
import { sanitizeHTML } from "../search/utils";

export function initFinancialsData(url) {
	const dataContainer = document.getElementById("financials-data");
	dataContainer.innerHTML = '<span class="loader">Loading...</span>';
	dataContainer.classList.add("loading");

	$.get(url)
		.done((response) => {
			dataContainer.innerHTML = sanitizeHTML(response);
			dataContainer.classList.remove("loading");
			setStickyTableColumn(dataContainer);
		})
		.fail(() => {
			dataContainer.innerText = "Failed to load data.";
			dataContainer.classList.remove("loading");
		});

	function setStickyTableColumn(dataContainer) {
		const table = dataContainer.querySelector(".table-container > table");

		if (!table) {
			return;
		}

		const hasHorizontalScroll =
			table.scrollWidth > table.parentElement.offsetWidth;
		if (hasHorizontalScroll) {
			table.classList.add("has-horizontal-scroll");
		}
	}
}
